<template>
  <div id="app">
    <AppHeader/>
    <transition name="views">
      <router-view/>
    </transition>
    <AppFooter/>
  </div>
</template>
<script>
import AppHeader from "@/components/AppHeader";
import AppFooter from "@/components/AppFooter";
export default {
  components: {
    AppHeader,
    AppFooter
  },
  mounted() {
    document.querySelector("body").classList.remove('load')
  }
}
</script>
<style lang="scss">
@import "public/static/style/style";
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
}
.views-enter-active, .views-leave-active {
  transition: opacity .4s;
}
.views-enter, .views-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
